import React, {useState, useRef, useEffect} from 'react';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import placemarkMap from '../../assets/images/placemarkMap.png';

interface IProps {
    contacts: any,
}

export const MapComponent = ({contacts}: IProps) => {
    const [isActive, setIsActive] = useState(false);
    const mapRef = useRef<any>(null);

    const mapCenter = [59.120225, 37.901638];
    const placemarkCoordinates = [59.120225, 37.901638];

    const mapCenter2 = [59.132422, 37.718007];
    const placemarkCoordinates2 = [59.132422, 37.718007];

    const defaultMapState = {
        center: contacts === 1 ? mapCenter : mapCenter2,
        zoom: 18,
        controls: ['fullscreenControl'],
    };

    const onMapLoad = React.useCallback((ymaps: any) => {
        if (ymaps && !mapRef.current) {
            mapRef.current = ymaps;
        }
    }, []);

    useEffect(() => {
        if (mapRef.current) {
            try {
                if (isActive) {
                    mapRef.current.behaviors.enable('drag');
                    mapRef.current.behaviors.enable('scrollZoom');
                    mapRef.current.behaviors.enable('dblClickZoom');
                } else {
                    mapRef.current.behaviors.disable('drag');
                    mapRef.current.behaviors.disable('scrollZoom');
                    mapRef.current.behaviors.disable('dblClickZoom');
                }
            } catch (error) {
                console.error('Error controlling map behaviors:', error);
            }
        }
    }, [isActive]);

    const handleActivate = () => {
        if (!isActive) {
            setIsActive(true);
        }
    };

    const handleDeactivate = () => {
        setIsActive(false);
    };

    return (
        <YMaps query={{ apikey: process.env.REACT_APP_YANDEX_KEY }}>
            <div
                onMouseLeave={handleDeactivate}
                style={{
                    width: '100%',
                    height: '660px',
                    position: 'relative',
                }}
            >
                <Map
                    instanceRef={onMapLoad}
                    onClick={handleActivate}
                    defaultState={defaultMapState}
                    width="100%"
                    height="660px"
                    modules={['control.FullscreenControl']}
                    options={{
                        suppressMapOpenBlock: true,
                        yandexMapDisablePoiInteractivity: !isActive,
                    }}
                >
                    <Placemark
                        geometry={contacts === 1 ? placemarkCoordinates : placemarkCoordinates2}
                        options={{
                            iconLayout: 'default#image',
                            iconImageHref: placemarkMap,
                            iconImageSize: [100, 190],
                            iconImageOffset: [-50, -190],
                        }}
                    />
                </Map>
                {!isActive && (
                    <div
                        onClick={handleActivate}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(255, 255, 255, 0.5)',
                            cursor: 'pointer',
                            zIndex: 1,
                        }}
                    />
                )}
            </div>
        </YMaps>
    );
};
